.modal-body {
  padding: 16px 16px 64px;
  line-height: 1.5;
  font-size: 16px;
}
